'use strict';

//Setting up route
angular.module('mean.users').config(['$httpProvider', 'jwtInterceptorProvider',
  function($httpProvider, jwtInterceptorProvider) {

    jwtInterceptorProvider.tokenGetter = function() {
      return localStorage.getItem('JWT');
    };

    $httpProvider.interceptors.push('jwtInterceptor');
  }
]);



//Setting up route
angular.module('mean.users').config(['$httpProvider', 'jwtOptionsProvider',
  function($httpProvider, jwtOptionsProvider) {
console.log('whitelisting domains now');
    jwtOptionsProvider.config({ 
      whiteListedDomains: ['ip-api.com'] 
    });
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/users/public/routes/auth.js